/**
 * Projet: Gestion des stagiaires
 * Auteur : Tim Allemann
 * Date : 30.11.2022
 * Description : Configurations des requêtes API pour les derniers contacts des entreprises
 * Fichier : lastContactService.js
 **/

import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL
const CONTROLLER = '/api/lastContacts'

export default {
  getLastContacts() {
    return axios.get(API_URL + CONTROLLER)
  },
  getLastContact(id) {
    return axios.get(API_URL + `${CONTROLLER}/${id}`)
  },
  postLastContact(lastContact) {
    return axios.post(API_URL + CONTROLLER, lastContact)
  },
  putLastContact(lastContact) {
    return axios.put(
      API_URL + `${CONTROLLER}/${lastContact.lastContactId}`,
      lastContact
    )
  },
  deleteLastContact(lastContactId) {
    return axios.delete(API_URL + `${CONTROLLER}/${lastContactId}`)
  }
}
